import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { Box } from '@radix-ui/themes';

import { useGetUserViewCampaigns } from '../../activityBoard/hooks/useGetUserViewCampaigns';
import { readableTextColor } from '../../../lib/helpers/readableTextColor';

import LoadingComponent from '../../../shared/LoadingComponent';
import Text from '../../../shared/Text';

export const MomentsContainer = props => {
  const { t } = useTranslation('moments');

  const {
    campaigns,
    isFetching,
    setSelectedCampaign,
  } = useGetUserViewCampaigns({
    slug: props.slug,
    boardSlug: props.demo.publicSlug,
  });

  if (isFetching) return <LoadingComponent />;

  return (
    <Box m={{ initial: '4', sm: '5' }} pb="72px">
      <Header>
        <Title>
          <Text variant="h3">
            {props.demo.momentsHeader || t('index.title')}
          </Text>
        </Title>
        <Text variant="subtitle1">{props.demo.momentsMessage}</Text>
      </Header>

      <MomentsList>
        {campaigns.map(campaign => {
          return (
            <MomentCard
              key={campaign.uuid}
              $cardColor={campaign.color}
              onClick={() => setSelectedCampaign(campaign)}
            >
              <Name>
                <Text
                  color={readableTextColor(campaign.color)}
                  variant="button"
                >
                  {campaign.name}
                </Text>
              </Name>
              <ImgContainer>
                <Image src={campaign.tileImage} alt="" />
              </ImgContainer>
            </MomentCard>
          );
        })}
      </MomentsList>
    </Box>
  );
};

const MomentsList = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 50px;
  justify-content: center;
`;

const MomentCard = styled.div`
  display: flex;
  align-items: flex-start;
  border-radius: 8px;
  background: ${props => props.$cardColor};
  cursor: pointer;
  width: 100%;
  overflow: hidden;
  height: 180px;
  max-width: 423px;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.3);
  transition: box-shadow 0.3s ease-in-out, transform 0.2s ease-in-out;

  &:hover {
    box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.4);
    transform: translateY(-5px);
  }
`;

const Name = styled.div`
  flex: 1;
  padding: 16px;
`;

const ImgContainer = styled.div`
  flex: 2;
  overflow: hidden;
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
  width: 100%;
  height: 100%;
`;

const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const Header = styled.div`
  text-align: center;
  margin-top: 34px;
  margin-bottom: 40px;
`;

const Title = styled.div`
  margin-bottom: 16px;
`;
